import React, { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "sonner";
import api from "../lib/api";

export default function ForcePasswordChange({ onDone }) {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (pw.length < 6) { toast.error("Mindestens 6 Zeichen."); return; }
    if (pw !== pw2) { toast.error("Passwörter stimmen nicht überein."); return; }
    setSaving(true);
    try {
      await api.changeOwnPassword(pw);
      toast.success("Passwort geändert. Willkommen!");
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Fehler beim Ändern.");
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
      <div className="bg-zinc-950 border border-zinc-800 w-full max-w-sm p-6 space-y-5">
        <div className="text-center space-y-2">
          <div className="w-10 h-10 rounded-full border border-amber-600 flex items-center justify-center mx-auto">
            <KeyRound size={18} className="text-amber-400" />
          </div>
          <div className="font-display font-black text-lg tracking-tight">Passwort ändern</div>
          <p className="text-xs text-zinc-400">Du verwendest ein temporäres Passwort. Bitte setze jetzt dein eigenes Passwort.</p>
        </div>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-display">Neues Passwort</div>
            <Input type="password" value={pw} onChange={e => setPw(e.target.value)}
              placeholder="Mindestens 6 Zeichen"
              className="bg-zinc-900 border-zinc-800" />
          </div>
          <div className="space-y-1.5">
            <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-display">Passwort bestätigen</div>
            <Input type="password" value={pw2} onChange={e => setPw2(e.target.value)}
              placeholder="Wiederholen"
              className="bg-zinc-900 border-zinc-800" />
          </div>
        </div>
        <Button onClick={submit} disabled={saving}
          className="w-full bg-white text-black hover:bg-zinc-200 font-display font-bold uppercase tracking-wider">
          {saving ? <Loader2 size={14} className="animate-spin mr-2" /> : <KeyRound size={14} className="mr-2" />}
          Passwort setzen
        </Button>
      </div>
    </div>
  );
}
